// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';
import Vue from 'vue';
import VueCarousel from 'vue-carousel';

import Es6Promise from 'es6-promise';
require('es6-promise').polyfill();
Es6Promise.polyfill();
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import Mui from 'vue-awesome-mui';
import App from './App'
import router from './router'

/* eslint-disable no-new */
import './assets/css/base.css';
import './assets/js/flexible.js';
import './assets/css/common.less'

// 审核自定义全局组件引入
import conformRate from './pages/layeraudit/component/conform-rate';
import deptDiscoveryRate from './pages/layeraudit/component/dept-discovery-rate';
import jobCategory from './pages/layeraudit/component/job-category';
import issueClosedRate from './pages/layeraudit/component/issue-closed-rate';
import issueList from './pages/layeraudit/component/issue-list';
import deptCloseRate from './pages/layeraudit/component/dept-close-rate';
import deptFinishRate from './pages/layeraudit/component/dept-finish-rate';
import jobTotal from './pages/layeraudit/component/job-total';
import deptUnfinishedTotal from './pages/layeraudit/component/dept-unfinished-total';
import planFinishRate from './pages/layeraudit/component/plan-finish-rate';
import productionCategory from './pages/layeraudit/component/production-category';
import questionCategory from './pages/layeraudit/component/question-category';

import ehsdeptDiscoveryRate from './pages/ehs/component/dept-discovery-rate';
import ehsDeptTotal from './pages/ehs/component/job-total';
import ehsIssueClosedRate from './pages/ehs/component/issue-closed-rate';
import ehsissueList from './pages/ehs/component/issue-list';


import eiAvgList from './pages/ei/component/ei-avg-list';
import eiDeptRate from './pages/ei/component/ei-dept-rate';
import eiTopList from './pages/ei/component/ei-top-list';
import eiImgList from './pages/ei/component/ei-img-list';
import eiTypeList from './pages/ei/component/ei-type-list';

// 审核自定义全局组件
Vue.component('lpa-conform-rate', conformRate)
Vue.component('lpa-dept-discovery-rate', deptDiscoveryRate)
Vue.component('lpa-job-category', jobCategory)
Vue.component('lpa-issue-close-rate', issueClosedRate)
Vue.component('lpa-issue-list', issueList)
Vue.component('lpa-dept-close-rate', deptCloseRate)
Vue.component('lpa-dept-finish-rate', deptFinishRate)
Vue.component('lpa-job-total', jobTotal)
Vue.component('lpa-dept-unfinished-total', deptUnfinishedTotal)
Vue.component('lpa-plan-finish-rate', planFinishRate)
Vue.component('lpa-production-category', productionCategory)
Vue.component('lpa-question-category', questionCategory)

// EHS自定义全局组件
Vue.component('ehs-dept-total', ehsDeptTotal)
Vue.component('ehs-dept-discovery-rate', ehsdeptDiscoveryRate)
Vue.component('ehs-issue-close-rate', ehsIssueClosedRate)
Vue.component('ehs-issue-list', ehsissueList)

// EI自定义全局组件
Vue.component('ei-avg-list', eiAvgList)
Vue.component('ei-dept-rate', eiDeptRate)
Vue.component('ei-top-list', eiTopList)
Vue.component('ei-type-list', eiTypeList)
Vue.component('ei-img-list', eiImgList)

// 引入 ECharts 主模块
var echarts = require('echarts');


//datav低版本不兼容问题,重写定义组件
// import borderBox7 from './components/box-7/main';
// import borderBox13 from './components/box-13/main';
// import borderBox1 from './components/box-1/main';
import scrollBoard from './components/scroll-board/main';
import scrollPic from './components/scroll-pic/main';
// import decoration5 from './components/decoration-5/main';
// import loading from './components/loading/main';

// Vue.component('dv-border-box-7', borderBox7)
// Vue.component('dv-border-box-13', borderBox13);
// Vue.component('dv-border-box-1', borderBox1);
 Vue.component('zd-scroll-board', scrollBoard);
 Vue.component('zd-scroll-pic', scrollPic)
// Vue.component('dv-decoration-5', decoration5);
// Vue.component('dv-loading',loading);


// dataV 插件按需引入,//高版本兼容,使用这种导入方式
//http://datav.jiaminghi.com/guide/
import dataV from '@jiaminghi/data-view'
 Vue.use(dataV);
// Vue.use(decoration5);
// Vue.use(borderBox13);
// Vue.use(borderBox1);
// Vue.use(borderBox7);
// Vue.use(scrollBoard);
// Vue.use(charts);
// Vue.use(fullScreenContainer);

Vue.use(ElementUI);
//Vue.use(Mui);

//跑马灯
Vue.use(VueCarousel);

Vue.config.productionTip = false
//vue全局注入echarts
Vue.prototype.$echarts = echarts

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js